export const SuppliersListingActions = {
  RetrieveSuppliersList: 'retrieveSuppliersList',
  RetrieveSuppliersRecordCount: 'retrieveSuppliersCount',
  UpdateSuppliersSortOrder: 'updateSuppliersSortOrder',
  UpdateSuppliersPaginationParameters: 'udpateSuppliersPaginationParameters',
  UpdateSuppliersActiveInactive: 'updateSuppliersListingFilter',
  DownloadSuppliersListAsExcel: 'downloadSuppliersListAsExcel',
  UpdateSuppliersList: 'SuppliersListingActions.UpdateSuppliersList'
};

export const SuppliersListingGetters = {
  SuppliersList: 'getSuppliersList',
  SortBy: 'getSuppliersListingSoryBy',
  SortDirection: 'getSuppliersListingSortDirection',
  SuppliersPerPage: 'getSuppliersListingPerPage',
  SupplierListingOffset: 'getSuppliersListingOffset',
  SuppliersRecordCount: 'getSuppliersListingRecordCount',
  SuppliersActiveInactive: 'getSuppliersListingActiveInactive',
  SupplierSearchParam: 'SuppliersListingGetters.SupplierSearchParam'
};

export const SuppliersListingMutations = {
  SetSuppliersList: 'setSuppliersList',
  SetSuppliersSortOrder: 'setSuppliersSortOrder',
  SetSuppliersPaginationParameters: 'setSuppliersPaginationParameters',
  ResetSuppliersPaginationOffset: 'resetSuppliersPaginationOffset',
  SetSuppliersRecordCount: 'setSuppliersRecordCount',
  SetSuppliersActiveInactive: 'setSuppliersActiveInactive',
  SetSuppliersSearchParam: 'SuppliersListingMutations.SetSuppliersSearchParam'
};
